export const contentKeys = {
  all: ["content"] as const,

  taskTypes: () => [...contentKeys.all, "task-types"] as const,

  runs: () => [...contentKeys.all, "runs"] as const,
  runsList: (take: number) => [...contentKeys.runs(), "list", { take }] as const,
  run: (runId: string) => [...contentKeys.runs(), runId] as const,
};
